import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Media, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../../NotificationPopUp';

import documentLogo from '../../../../styles/images/documentIcon.svg';

import * as authenticationActions from '../../../../actions/authenticationActions';
import * as commonActions from '../../../../actions/commonActions';

import ConfirmationModal from '../../../common/ConfirmationModal';
import SimpleFileInput from '../../../common/SimpleFileInput';

class DocumentsSection extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            authenticationState: this.props.authenticationState,
            commonState: this.props.commonState,
            documentToBeAdded: {},
            eliminaDocumentoModal: {
                documentId: -1,
                show: false
            }
        };

        this.documentLoad = this.documentLoad.bind(this);
        this.eliminaDocumento = this.eliminaDocumento.bind(this);
        this.showEliminaDocumentoModal = this.showEliminaDocumentoModal.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.commonState !== prevState.commonState)
            return Object.assign({}, prevState, { commonState: nextProps.commonState });
        return null;
    }

    documentLoad(documentToBeAdded, configurationFilePreviewUrl) {
        this.props.caricaDocumento(this.props.user.id, documentToBeAdded).then(() => {
            notificationPopUp.success('Documento Caricato.');
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    eliminaDocumento() {
        this.props.eliminaDocumento(this.state.eliminaDocumentoModal.documentId).then(() => {
            notificationPopUp.success('Documento Eliminato');
            this.showEliminaDocumentoModal(null);
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    showEliminaDocumentoModal(doc) {
        const eliminaDocumentoModal = Object.assign({}, this.state.eliminaDocumentoModal);
        eliminaDocumentoModal.show = !eliminaDocumentoModal.show;

        if (!_.isNil(doc) && !_.isNil(doc.id))
            eliminaDocumentoModal.documentId = doc.id;
        else
            eliminaDocumentoModal.documentId = -1;

        this.setState(Object.assign({}, this.state, { eliminaDocumentoModal }));
    }

    render() {
        return (
            <div className="panel panel-default x-panel">
                <div className="panel-heading">Documenti Privati</div>
                <div className="panel-body">
                    <Row>
                        {this.props.user.documents.map(doc => {
                            return (<Col md={4} key={doc.id}><Media>
                                <Media.Left>
                                    <img width={48} height={48} src={documentLogo} alt='Documento' />
                                </Media.Left>
                                <Media.Body>
                                    <Media.Heading>
                                        <a target='_blank' rel="noopener noreferrer" href={process.env.REACT_APP_USER_DOCUMENT_URL + doc.id + '?token=' + encodeURI(this.state.authenticationState.token)}> {doc.name} </a>
                                        <span className='glyphicon glyphicon-trash' onClick={() => this.showEliminaDocumentoModal(doc)} style={{ cursor: 'pointer' }}></span>
                                    </Media.Heading>
                                </Media.Body>
                            </Media></Col>);
                        })}
                    </Row>
                    <hr />
                    <Row>
                        <Col md={12}>
                            <SimpleFileInput name='documentLoader' label='Scegli e Carica File' onLoaded={this.documentLoad} />
                        </Col>
                    </Row>
                </div>
                <ConfirmationModal
                    title='Conferma Eliminazione di un Documento'
                    message={'Confermi di volere ELIMINARE il documento ?'}
                    show={this.state.eliminaDocumentoModal.show}
                    showHide={this.showEliminaDocumentoModal}
                    action={this.eliminaDocumento}
                    commonState={this.state.commonState}
                />
            </div>
        );
    }
}

DocumentsSection.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    caricaDocumento: PropTypes.func.isRequired,
    commonState: PropTypes.object.isRequired,
    eliminaDocumento: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        commonState: state.commonState,
        authenticationState: state.authenticationState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        authenticationActions: bindActionCreators(authenticationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsSection);
